<template>
  <div class="pattern-page-module">
    <app-header v-bind="headerConfig"></app-header>
    <!-- swiper -->
    <div class="inner">
      <swiper :options="swiperOption" ref="mySwiper" class="story-types">
        <swiper-slide v-for="type in $store.state.parrent.types" :key="type.id">
          <img :src="type.pic" :alt="type.name">
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination"></div>
      <a href="javascript:;" class="type-hint" id="js-types-hint" @click="createType">
        {{nowType}}
      </a>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ComponentName, Methods} from '../const/common';
  import configText from '../config/ConfigText';
  require('swiper/dist/css/swiper.css');

  export default {
    name: 'pattern',
    components: {
      'app-header': AppHeader
    },
    data () {
      return {
        headerConfig: {
          title: configText.startToCreate,
          isStoryMenu: false,
          backPage: store.state.nextPageHeaderConf.pattern.backPage,
          backNote: store.state.nextPageHeaderConf.pattern.backNote,
          closeModule: ComponentName.PUTTERN
        },
        nowTypeIndex: 0,
        nowType: configText.createChat[0],
        swiperOption: {
          pVue:this,
          notNextTick: true,
          effect: 'coverflow',
          centeredSlides: true,
          slidesPerView: 'auto',
          loopedSlides: 3,
          coverflowEffect: {
            rotate: 0,
            stretch: 140,
            depth: 150
          },
          pagination: {
            el: '.swiper-pagination',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>'
            }
          },
          uniqueNavElements: false,
          paginationClickable: true,
          on: {
            slideChange: function (e) {
              this.params.pVue.nowType=configText.createChat[this.activeIndex];
              this.params.pVue.nowTypeIndex = this.activeIndex;
            }
          }
        }
      }
    },
    store,
    methods: {
      createType () {
        store.state.nextPageHeaderConf['creation'] =  {
          backPage: ComponentName.PUTTERN,
          backNote: '模式选择'
        };
        store.state.parrent.createPattern = this.nowTypeIndex;
        Methods.cutComponent('all', false);
        Methods.cutComponent([ComponentName.CREATEION_TYPE], true);
        Methods.checkChapterHash(4);
      }
    }
  }
</script>

<style>
  @import "../style/css/pattern.css";
</style>



// WEBPACK FOOTER //
// src/components/pattern.vue